import React, { useState } from "react";
import { Loader2 } from "lucide-react";

const inputCls = "w-full bg-candy-cream text-candy-night text-base font-semibold placeholder:text-candy-night/50 border-4 border-black rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-candy-gold";

export const SpinForm = ({ onSpin, spinning }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onSpin(name.trim(), email.trim());
  };

  return (
    <form onSubmit={submit} className="mt-6 space-y-3" data-testid="spin-form">
      <label className="block">
        <span className="sr-only">Your name</span>
        <input data-testid="spin-name-input" required maxLength={60} value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className={inputCls} />
      </label>
      <label className="block">
        <span className="sr-only">Your email</span>
        <input data-testid="spin-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className={inputCls} />
      </label>
      <button
        type="submit"
        disabled={spinning}
        data-testid="spin-submit-btn"
        className="w-full bg-candy-pink text-white font-extrabold uppercase text-lg tracking-wider py-4 border-4 border-black rounded-xl shadow-glow-orange hover:-translate-y-0.5 transition-transform disabled:opacity-70 flex items-center justify-center gap-2"
      >
        {spinning ? <><Loader2 className="h-5 w-5 animate-spin" /> Spinning…</> : "Spin the Wheel"}
      </button>
      <p className="text-sm text-candy-cream/80 leading-relaxed" data-testid="spin-email-notice">
        We'll email you your prize and occasional Sweet Tooth Bandit deals. Unsubscribe anytime. Up to 3 tries per email, 1 prize per email.
      </p>
    </form>
  );
};
